export default __webpack_public_path__ + "static/media/home.faa3013e.svg";